
import React, { Component } from "react";
import {Icon, Rate} from 'antd'

import {AMENITY_ICON_TYPE_MAP, AMENITY_ICON_COLOR_MAP} from '../../constants'
class AmbAmenitiesTabletReview extends Component{

    constructor(props){
        super(props)
        this.fa_icon_map = {"HotTub":"et-icon-help","Spa":"et-icon-help","Swimming_pool":"et-icon-help","Free_Wifi":"et-icon-help","Free_Parking":"et-icon-help","Bath_Tub":"et-icon-help","24_Hrs Fitness":"et-icon-help","Restaurants":"et-icon-help","Key_Card Access":"et-icon-help","Non_Smoking":"et-icon-help","Elevator":"et-icon-help","Shuttle_Service":"et-icon-help","Snorkling_Service":"et-icon-help","Laundry":"et-icon-help"}
    }
    render(){
        const ars = [];
        console.log('############### this.props.amenities')
        console.log(this.props.amenities)
       
        /*
        let borderVal = this.props.border  || "1px solid rgb(204, 230, 213)"
        let backgroundColorVal = this.props.backgroundColor || "#baf7f4"
        */
       
        let iconMap = {
            "BAGGAGE":{"type":"contacts", "color" :"#e14a4a"},
            "MEAL":{"type":"audio", "color" :"#829d21"},
            "ENTERTAINMENT_USB":{"type":"bank", "color" :"#5a7ed2"},
            "ENTERTAINMENT_AC":{"type":"bulb", "color" :"#aa2f96"},
            "OTHERS2":{"type":"fund", "color" :"#122a96"},
         }


       
        const sv_ams_li = this.props.amenities.map((o, idx)=>{
            console.log("##################am name:", o)
            let txt = o.isChargeable? "Pay To" :'Free'
            let itype = iconMap['OTHERS2']
            let ifound = iconMap['BANK']
            let iamen = o.amenityType
            let s = ''
            if(o.amenityType == 'ENTERTAINMENT'){
                 s = o.description
                itype = iconMap["OTHERS2"]
                iamen = o.description
                
                
                if(s.indexOf("AC") > 0){
                        itype = iconMap[o.amenityType+'_'+'AC']
                }
                if(s.indexOf("USB") > 0){
                    itype = iconMap[o.amenityType+'_'+'USB']
                }
            }else{
                 itype =  iconMap[o.amenityType] ? iconMap[o.amenityType] : ifound
                
            }

          

            return (
                <div className="c-box-tablet">
                <span style={{
                    fontSize: "2em",
                    marginTop:"10px",
                    marginLeft:"10px",
                    border: "",
                    backgroundColor:"",
                    padding: "5px"
                }}> 
                    <text className="svr-hotel-name"  style={{fontSize:"14px",verticalAlign: "middle" ,paddingRight:"10px",color:"rgb(101, 112, 119)"}}>{txt} {iamen}</text>
                {/* 
                 <Icon  style={{ color:itype.color , fontSize:"20px" }} type={itype.type} theme="filled" />
            
                */}
                    <Icon  style={{ color:"#123456" , fontSize:"20px" }} type="audio" theme="filled" />
                </span>
               </div>
                
                )

            });

       
            return (
                <div className="container-fluid">
                     <div className="svr-gal-contentWrapper">                 
                     <div className="svr-amenity-content" >
                         <div className="svr-amenity-list-full">
                    
                        <div className="c-container-tablet">
                        {sv_ams_li}
                        </div>
                        </div>
                   
    
    
                     </div>
                    </div>
                </div>
            )
        
    }
   
}

export default AmbAmenitiesTabletReview;